import {ButtonPulse} from "./Button";
import {ItemModel, ItemType} from "../Data/ItemModel";
import {Photo} from "./Puzzle/Photo";
import {photo as photoLayout} from "../Layout/PuzzleScreenLayout";
import {PuzzleModel} from "./Puzzle/PuzzleModel";
import {Sprite} from "../Core/Sprite";
import {Container} from "../Core/Container";
import {AssemblyModel} from "./Assembly/AssemblyModel";
import {CookingModel} from "./Cooking/CookingModel";
import * as PIXI from "pixi.js";
import {MovieSlot} from "./Assembly/MovieModel";
import {Bagpipes} from "./Music/Bagpipes";
import {KitHoverVO} from "../Data/VoiceOver";

export abstract class ShelfItemButton extends ButtonPulse {

    readonly itemType: ItemType;
    protected itemVisual?: Container;

    constructor(itemType: ItemType) {
        super();
        this.itemType = itemType;
        this.visible = false;
        this.enabled = false;
        this.sprite.visible = false;

        // Fix of hover VO played right after creation of the item
        this.delayedCall(0.4, () => this.hoverVO = KitHoverVO[itemType]);
    }

    setItem(model: ItemModel) {
        if (this.itemVisual) {
            this.itemVisual.destroy();
        }
        this.visible = true;
        this.enabled = true;
    }

    getItemVisual() {
        return this.itemVisual;
    }
}

export class ShelfItemAssembly extends ShelfItemButton {

    setItem(model: ItemModel) {
        super.setItem(model);

        const sprite = this.visuals.addChild(new Sprite());
        const render = (model.itemData as AssemblyModel<MovieSlot>).render;
        if (render) {
            PIXI.Texture.fromURL(render).then(t => {
                sprite.texture = t;
                sprite.zIndex = 0;
                sprite.setBounds(this.sprite, "fit");
                sprite.alignBy(this.sprite, 0.5, 1);
            }).catch(() => {
                // ignore
            });
        }

        this.itemVisual = sprite;
    }
}

export class ShelfItemPuzzle extends ShelfItemButton {

    public readonly photoHanger = this.visuals.addChild(new Sprite());

    constructor() {
        super(ItemType.Puzzle);
    }

    setItem(model: ItemModel) {
        super.setItem(model);

        const photo = new Photo();
        photoLayout.call(photo);
        photo.setModel(model.itemData as PuzzleModel);
        this.visuals.addChild(photo);
        photo.setBounds(this.sprite);
        photo.alignBy(this.sprite, 0.5, 0.5);

        this.itemVisual = photo;
    }
}

export class ShelfItemMusic extends ShelfItemButton {

    setItem(model: ItemModel) {
        super.setItem(model);
        this.sprite.visible = true;
        this.itemVisual = this.sprite;
    }
}

export class ShelfItemBagpipes extends ShelfItemButton {

    readonly bagpipes = new Bagpipes();

    constructor() {
        super(ItemType.Bagpipes);
    }

    setItem(model: ItemModel) {
        super.setItem(model);
        this.itemVisual = this.bagpipes;
        this.visuals.addChild(this.bagpipes);
    }
}

export class ShelfItemCooking extends ShelfItemButton {

    setItem(model: ItemModel) {
        super.setItem(model);

        const sprite = new Sprite(`recipe-book-${(model.itemData as CookingModel).cookingType}`);
        this.visuals.addChild(sprite);
        sprite.setBounds(this.sprite);
        sprite.alignBy(this.sprite, 0.5, 1);

        this.itemVisual = sprite;
    }
}